export default "__VITE_ASSET__DSX6falw__"